import { Edit3, Save } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function AppNameSection({
  appName,
  editingAppName,
  tempAppName,
  setTempAppName,
  loading,
  onStartEditing,
  onSave,
  onCancel,
}) {
  return (
    <div className="card-base p-6">
      <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-4 flex items-center gap-2">
        <Edit3 size={20} className="text-emerald-400" />
        Customization
      </h2>

      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 rounded-xl bg-slate-800/50">
          <div>
            <p className="text-white font-medium">App Name</p>
            <p className="text-sm text-slate-400">
              Personalize your family hub name
            </p>
          </div>
          {editingAppName ? (
            <div className="flex items-center gap-2">
              <Input
                value={tempAppName}
                onChange={(e) => setTempAppName(e.target.value)}
                className="w-40 bg-slate-950 border-slate-700"
                placeholder="App name"
                data-testid="app-name-input"
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === "Enter") onSave();
                  if (e.key === "Escape") onCancel();
                }}
              />
              <Button
                size="sm"
                onClick={onSave}
                disabled={loading}
                className="bg-emerald-600 hover:bg-emerald-500"
                data-testid="save-app-name"
              >
                <Save size={16} />
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={onCancel}
                className="border-slate-700"
              >
                Cancel
              </Button>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <span className="text-indigo-400 font-medium">{appName}</span>
              <Button
                variant="outline"
                size="sm"
                onClick={onStartEditing}
                className="border-slate-700"
                data-testid="edit-app-name"
              >
                <Edit3 size={14} className="mr-1" />
                Edit
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
